import React, { useState } from 'react';
import API_BASE_URL from '../../../../Constants';


const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]); 
  const [success, setSuccess] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!file) {
      setErrors(['Please select a file to upload.']);
      setSuccess('');
      return;
    }
  
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/upload-excel`, {
        method: 'POST',
        body: formData,
        credentials: 'include', // Include credentials for CORS requests
      });
  
      if (response.ok) {
        const data = await response.json();
        if (data.errors) {
          setErrors(data.errors);
          setSuccess('');
        } else {
          setSuccess('File uploaded and processed successfully.');
          setErrors([]);
        }
      } else {
        throw new Error('Failed to upload file.');
      }
    } catch (error) {
      setErrors(['Failed to upload file.']);
      setSuccess('');
    }
  };
  

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5'
  };

  const uploadBoxStyle = {
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    textAlign: 'center'
  };

  return (
    <div style={containerStyle}>
      <div style={uploadBoxStyle}>
        <h2>Upload Data</h2>
        <input type="file" onChange={handleFileChange} />
        <button onClick={handleFileUpload}>Upload</button>
        {success && <p style={{ color: 'green' }}>{success}</p>}
        {errors.length > 0 && (
          <ul style={{ color: 'red' }}>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
